exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fun-facts-m{border-radius:10%;color:#fff;display:table;height:100px;margin:0 auto;text-align:center;width:100%;background:#c91b1b}", ""]);

// exports
